module.exports = __webpack_public_path__ + "static/media/OpenDyslexic-Regular.0a6190b2.woff";